import { APIService } from "../../../../network/api/APIService";

export const SymbolsData = ({ eaId }) => {
    let endpoint = `/ea/symbols/?ea=${encodeURIComponent(eaId)}`;
    
    const config = {
        endpoint: endpoint,
        method: "GET",
        credentials: "include",
    };

    return APIService(config);
};